import React from 'react';
import { TextArea, Text } from 'library';

const ReferralCopyInput = ({ message, setMessage }: { message: string; setMessage: (message: string) => void }) => {
    return (
        <>
            <TextArea value={message} onChange={(e) => setMessage(e.target.value)} style={{ marginTop: 20 }} />
            <Text variant="body2" textStyle={{ marginLeft: 10, marginTop: 8 }}>
                Send this message or customize your own!
            </Text>
        </>
    );
};

export default ReferralCopyInput;
